import {Component, Input, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'wsd-select-organization',
  templateUrl: './select-organization.component.html',
  styleUrls: ['./select-organization.component.css']
})
export class SelectOrganizationComponent {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_ORGANIZATION.LABEL';

  organizationItems: SelectItem[] = [];

  constructor() { }

}
